export default "__VITE_ASSET__2261b322__"